import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { ScrollToTop } from "./components";
import configureStore from "./store/configureStore";
import routes from "./routes";
import "./assets/css/index.scss";
// import registerServiceWorker from "./registerServiceWorker";

window.matchMedia =
  window.matchMedia ||
  function() {
    return {
      matches: false,
      addListener: function() {},
      removeListener: function() {}
    };
  };

const store = configureStore();

ReactDOM.render(
  <Provider store={store} key="provider">
    <BrowserRouter>
      <ScrollToTop>{renderRoutes(routes)}</ScrollToTop>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js